export default {
    'TablaFlujo.AnularDocumento': 'Flujos',
    'TablaFlujo.Acciones': 'Acciones',
    'TablaFlujo.Estado': 'Estado',
    'TablaFlujo.Descripcion': 'Descripción',
};
